<div class="progress-wrapper" id="main-content" *ngIf="(cart$ | async).shopping_cart_id">
    <ridango-page-content-wrapper>
        <ridango-progress-v2 [steps]="steps$ | async" [activeStep]="activeStep$ | async"> </ridango-progress-v2>
    </ridango-page-content-wrapper>
</div>

<div class="block--content block" *ngIf="(cart$ | async).shopping_cart_id">
    <div class="block--wrap block">
        <div class="ticket">
            <rwidget-alert></rwidget-alert>

            <div class="intro-text">
                <h1 class="title">
                    {{ 'SHOPPING_CART_INTRO_TITLE' | translate }}
                </h1>
                <p>
                    {{ 'SHOPPING_CART_INTRO_DESCRIPTION' | translate }}
                </p>
            </div>

            <rwidget-cart-tickets></rwidget-cart-tickets>
            <ridango-arrow-down-separator></ridango-arrow-down-separator>

            <!-- terms -->
            <rwidget-cart-terms *ngIf="!this.ridangoAuth.getLoginStatus()"> </rwidget-cart-terms>
            <ridango-arrow-down-separator *ngIf="!this.ridangoAuth.getLoginStatus()"></ridango-arrow-down-separator>

            <!-- payment -->
            <rwidget-cart-payment-methods></rwidget-cart-payment-methods>
            <ridango-arrow-down-separator></ridango-arrow-down-separator>

            <!-- swish -->
            <rwidget-cart-swish *ngIf="(selectedPaymentMethod$ | async)?.payment_type === paymentTypeEnum.SWISH">
            </rwidget-cart-swish>
            <ridango-arrow-down-separator
                *ngIf="(selectedPaymentMethod$ | async)?.payment_type === paymentTypeEnum.SWISH">
            </ridango-arrow-down-separator>
        </div>
    </div>

    <div class="block--bg-wrapper ticket-summary" *ngIf="(cart$ | async).shopping_cart_id">
        <rwidget-cart-summary (swishIdInvalid)="swishInvalid()" (onSwishSuccess)="handleSwishSuccess()">
        </rwidget-cart-summary>
    </div>
</div>

<ridango-page-content-wrapper *ngIf="!(cart$ | async).shopping_cart_id">
    <div class="block--content block" id="main-content">
        <div class="ticket">
            <rwidget-alert></rwidget-alert>

            <rwidget-cart-empty
                *ngIf="environment.EMPTY_CART_OPTIONS.SHOPPING_CART_TYPE === emptyCartOptions.BUY_PERIOD_OR_LOAD_MONEY">
                <div class="empty-status-shopping-cart-buttons__search">
                    <button class="btn btn--big btn--maximal btn--primary" [routerLink]="'/purchase/wallet' | localize">
                        {{ 'EMPTY_STATUS_LOAD_MONEY' | translate }}
                    </button>
                </div>
                <div class="empty-status-shopping-cart-buttons__periodticket">
                    <button class="btn btn--big btn--maximal btn--primary" [routerLink]="'/purchase/ticket' | localize">
                        {{ 'EMPTY_STATUS_BUY_PERIOD_TICKET' | translate }}
                    </button>
                </div>
            </rwidget-cart-empty>

            <rwidget-cart-empty
                *ngIf="environment.EMPTY_CART_OPTIONS.SHOPPING_CART_TYPE === emptyCartOptions.BUY_PERIOD">
                <div class="empty-status-shopping-cart-buttons__periodticket btn-center">
                    <button class="btn btn--big btn--maximal btn--primary" [routerLink]="'/purchase/ticket' | localize">
                        {{ 'EMPTY_STATUS_BUY_PERIOD_TICKET' | translate }}
                    </button>
                </div>
            </rwidget-cart-empty>
        </div>
    </div>
</ridango-page-content-wrapper>
